<template>
  <component
    :is="as || 'div'"
    :class="$style.wrap"
    :style="`--container-max-width: ${
      typeof maxWidth === 'number' ? maxWidth + 'px' : maxWidth
    }`"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
defineProps<{
  as?: string
  maxWidth: number
}>()
</script>

<style lang="scss" module>
.wrap {
  margin: 0 auto;
  padding: 0 var(--container-padding-x, 1.75rem);
  max-width: calc(
    var(--container-max-width) + var(--container-padding-x, 1.75rem) +
      var(--container-padding-x, 1.75rem)
  );
}
</style>
